export const maxContainerMobileWidth = 600;
